import { IState } from 'legacy/lut/store'

export const selectGeneralReportsState = (state: IState) => state.partner360.generalReports
